import { useMemo } from 'react';

export type Permission = 'dashboard' | 'vendors' | 'users' | 'events' | 'orders' | 'analytics';

const ROLE_PERMISSIONS: Record<string, Permission[]> = {
  'super-admin': ['dashboard', 'vendors', 'users', 'events', 'orders', 'analytics'],
  admin: ['dashboard', 'vendors', 'users', 'events', 'orders', 'analytics'],
  editor: ['dashboard', 'vendors', 'events', 'orders', 'analytics'],
  vendor: ['dashboard', 'vendors', 'orders', 'analytics'],
  'read-only': ['dashboard', 'analytics'],
  preparer: ['dashboard', 'orders'],
  deliverer: ['dashboard', 'orders'],
};

export interface CurrentUser {
  id: string;
  name: string;
  role: string;
  permissions?: Permission[];
}

function readCurrentUser(): CurrentUser | null {
  const raw = localStorage.getItem('oni_current_user');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as CurrentUser;
  } catch {
    return null;
  }
}

export function usePermissions() {
  const user = readCurrentUser();

  const permissions = useMemo(() => {
    if (user?.permissions?.length) return user.permissions;
    const role = (user?.role || '').toLowerCase();
    return ROLE_PERMISSIONS[role] || ['dashboard'];
  }, [user]);

  const can = (permission: Permission) => permissions.includes(permission);

  const canManageVenueSettings =
    user?.role === 'super-admin' || user?.role === 'admin';

  return { user, permissions, can, canManageVenueSettings };
}
export default usePermissions;
